import React from 'react';
import { browserHistory } from 'react-router';

import {
  restaurantById,
  bookingAvailabilitySelector,
} from '@arreeba/ristoranti-frontend-lib/lib/selectors/booking';

import { urlSelector } from '../../selectors/urlSelectors';
import { connect } from '../../util';
import Url from '../../lib/url';

import BackButton from '../../components/back-button';
import BookingDateRow from '../../components/booking-date-row';
import BookingError from './booking-error';



const BookingSelectDate = (props) => {
  const { ux, actions, bookingAvailability } = props;
  const targetRestaurant = props.routeParams.restaurantId;
  const restaurant = restaurantById(props.app.merchant.restaurants, targetRestaurant);

  if (ux.message.title) {
    return React.createElement(BookingError, props);
  }

  const selectRestaurantHref = Url.booking(props.url.appId);
  const setBookingDate = (data) => {
    actions.booking.setBookingDate(data);
    browserHistory.push(
      Url.bookingDate(
        props.url.appId,
        props.url.restaurantId,
        data.date,
      ),
    );
  };

  return (
    <main>
      <p className="booking-info">
        <strong>{restaurant.name}</strong> – {restaurant.address}.
      </p>

      <p>Scegli la data in cui vuoi prenotare.</p>

      <ul className="grow mobile-list">
        {bookingAvailability.map(day => (
          <BookingDateRow
            {...day}
            date={day.date.split('T')[0]}
            key={day.date}
            onClick={setBookingDate}
          />
        ))}
      </ul>
      <BackButton to={selectRestaurantHref} />
    </main>
  );
};


const targetRestaurant = (state, props) => props.routeParams.restaurantId;
const connectOptions = {
  mapStateToProps: (state, props) => ({
    ...state,
    url: urlSelector(state, props),
    bookingAvailability: bookingAvailabilitySelector(targetRestaurant)(state, props),
  }),
};


export default connect(BookingSelectDate, connectOptions);



// WEBPACK FOOTER //
// ./src/containers/booking/booking-select-date.js